import { Typography, Space } from 'antd'
import CIMSLink from 'components/CIMSLink'
import { SharePointExternalLinkProps } from './types'

const SharePointExternalLink: React.FC<SharePointExternalLinkProps> = ({
  webUrl,
  parent,
}) => {
  return (
    <CIMSLink
      external
      href={webUrl}
      tooltip={
        !webUrl
          ? {
              title: `Could not find a SharePointResource for this record`,
              content: (
                <Space
                  size="small"
                  direction="vertical"
                  style={{ maxWidth: 300 }}
                >
                  <Typography.Text>
                    SharePoint Folder links are retrieved using the{' '}
                    {parent.description}, and are temporarily cached to increase
                    performance.
                  </Typography.Text>
                  <Typography.Text>
                    If a user modifies the folder name in SharePoint instead of
                    CIMS, these links can appear broken as the expected pattern
                    will not be found.
                  </Typography.Text>
                  <Typography.Text>
                    To fix a broken link, update the folder name in SharePoint
                    to match the expected pattern in CIMS ({parent.description})
                    and click Reload.
                  </Typography.Text>
                  <Typography.Text>
                    If steps have been followed to fix a broken link and issues
                    persist, contact a Project Admin to reach out for
                    assistence.
                  </Typography.Text>
                </Space>
              ),
            }
          : undefined
      }
    >
      SharePoint Folder
    </CIMSLink>
  )
}

export default SharePointExternalLink
